import LongArrow from 'App/pages/Assets/icons/largearrow_png_transparent.png';
import 'App/pages/Media/Lightbox.css';
import { RichText } from 'prismic-reactjs';
import linkResolver from 'prismic-configuration.js';

export function FeatureItem(body) {
  const { slice } = body;
  const { image } = slice.primary;
  const orientation = slice.slice_label;
  let arrow = null;
  slice.primary.headline.forEach((headline) => {
    headline.spans.forEach((span) => {
      if (span.type === 'hyperlink') {
        arrow = <img src={LongArrow} className="ml-1 longArrow" alt="->" />;
      }
    });
  });
  return (
    <div className="my-5 row justify-content-center featuredItem">
      <div
        className={`p-0 col-10 column-image card align-content-stretch ${orientation}`}
      >
        <div className="fiTitle card-header">
          {RichText.render(slice.primary.headline, linkResolver)}
          {arrow}
        </div>
        <div className="fiImage bg-light">
          <picture className="mt-5">
            <source media="(max-width: 400px)" srcSet={image.mobile.url} />
            <source srcSet={image.url} />
            <img src={image.url} alt={image.alt} />
          </picture>
        </div>
      </div>
      {RichText.asText(slice.primary.featured_item_description) !== '' && (
      <div
        className="col-lg-4 col-md-4 col-10 column-text align-self-center"
        style={{ backgroundColor: '#eaa12e', color: '#fff' }}
      >
        {RichText.render(
          slice.primary.featured_item_description,
          linkResolver,
        )}
      </div>
      )}
    </div>
  );
}
export default FeatureItem;
